import { useDispatch } from "react-redux";
import type { AppDispatch } from "~/store/types.d.ts";

export default function useAppDispatch(): AppDispatch {
	return useDispatch();
}
